export const OFFER_LIST_CARD_CONTENT = {
    ADD_TO_FAVORITES: "Dodaj do ulubionych",
    ASK_BUTTON: "Zapytaj",
    ASK_OFFER_BUTTON: "Zapytaj o ofertę",
    COMPARE_BUTTON: "Porównaj",
    DELETE_FROM_FAVORITES: "Usuń ofertę z ulubionych",
    FLOOR_UNIT: "piętro",
    getOpenGalleryAriaLabel: (address: string) => `Otwórz galerię oferty ${address}`,
    getViewDetailsAriaLabel: (address: string) => `Zobacz szczegóły oferty ${address}`,
    GROUND_FLOOR: "Parter",
    INQUIRY_SENT_BADGE: "Wysłano zapytanie",
    MENU_ARIA_LABEL: "Opcje oferty",
    PENDING_SENDING_LABEL: "W trakcie wysyłania...",
    RP_SOURCE_LABEL: "RynekPierwotny.pl",
    READY_LABEL: "Gotowe"
} as const;
export const OFFER_LIST_CARD_CONTENT = {
    ADD_TO_FAVORITES: "Dodaj do ulubionych",
    ASK_BUTTON: "Zapytaj",
    ASK_OFFER_BUTTON: "Zapytaj o ofertę",
    COMPARE_BUTTON: "Porównaj",
    DELETE_FROM_FAVORITES: "Usuń ofertę z ulubionych",
    FLOOR_UNIT: "piętro",
    getOpenGalleryAriaLabel: (address: string) => `Otwórz galerię oferty ${address}`,
    getViewDetailsAriaLabel: (address: string) => `Zobacz szczegóły oferty ${address}`,
    GROUND_FLOOR: "Parter",
    INQUIRY_SENT_BADGE: "Wysłano zapytanie",
    MENU_ARIA_LABEL: "Opcje oferty",
    PENDING_SENDING_LABEL: "W trakcie wysyłania...",
    RP_SOURCE_LABEL: "RynekPierwotny.pl",
    READY_LABEL: "Gotowe"
} as const;
